import { render, staticRenderFns } from "./SettingMenu.vue?vue&type=template&id=10fe20fb"
import script from "./SettingMenu.vue?vue&type=script&lang=js"
export * from "./SettingMenu.vue?vue&type=script&lang=js"
import style0 from "./SettingMenu.vue?vue&type=style&index=0&id=10fe20fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports